// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Atom_Cta = require("../../atom/Atom_Cta.bs.js");
var Util_Dom = require("../../../util/Util_Dom.bs.js");
var Atom_Cell = require("../../atom/Atom_Cell.bs.js");
var Atom_Text = require("../../atom/Atom_Text.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Atom_Textfield = require("../../atom/Atom_Textfield.bs.js");
var Atom_Icon_Internal = require("../../atom/icon/Atom_Icon_Internal.bs.js");
var Particle_Screen_Ds = require("../../particle/Particle_Screen_Ds.bs.js");
var Particle_Spacer_Ds = require("../../particle/Particle_Spacer_Ds.bs.js");
var UseTrackingAmplitude = require("../../../hook/UseTrackingAmplitude.bs.js");
var Webapi__Dom__Element = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.bs.js");
var Particle_Accessibility = require("../../particle/Particle_Accessibility.bs.js");
var Particle_Screen_Constants = require("../../particle/Particle_Screen_Constants.bs.js");

function Organism_SearchNavigation(Props) {
  var searchNavigation = Props.searchNavigation;
  var onChange = Props.onChange;
  var placeholder = Props.placeholder;
  var initialQuery = Props.initialQuery;
  var state = Props.state;
  var toggle = Props.toggle;
  var numberResultsLabelOpt = Props.numberResultsLabel;
  var numberResultsLabel = numberResultsLabelOpt !== undefined ? numberResultsLabelOpt : "";
  var ref = React.useRef(null);
  var match = React.useState(function () {
        return /* First */0;
      });
  var setDisplayStatus = match[1];
  var displayStatus = match[0];
  React.useEffect((function () {
          var match = Util_Dom.getDomRef(ref);
          if (displayStatus && match !== undefined) {
            Belt_Option.forEach(Webapi__Dom__Element.asHtmlElement(Caml_option.valFromOption(match)), (function (prim) {
                    prim.focus();
                  }));
          }
          
        }), [state]);
  var trackAmplitude = UseTrackingAmplitude.useUserAction("search_button");
  var handleOpen = function (evt) {
    Curry._1(setDisplayStatus, (function (param) {
            return /* Others */1;
          }));
    Curry._1(toggle, evt);
    Curry._1(trackAmplitude, undefined);
  };
  var handleSearchLinkCkick = function (param) {
    Curry._1(trackAmplitude, undefined);
  };
  return React.createElement(Atom_Cell.make, {
              accessibility: Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Search", undefined, undefined),
              height: Particle_Screen_Constants.oneHundredPctHeight,
              children: null
            }, onChange !== undefined ? (
                state ? React.createElement(Atom_Cta.Button.make, {
                        ctaRef: ref,
                        onClick: handleOpen,
                        screenReadersLabel: searchNavigation.displayLabel,
                        style: {
                          TAG: /* Header */10,
                          _0: /* Search */4
                        }
                      }) : React.createElement(Atom_Cell.make, {
                        alignItems: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "center"),
                        border: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                              TAG: /* Cta */2,
                              _0: /* Active */0,
                              _1: "Medium"
                            }),
                        children: null
                      }, React.createElement(Atom_Cell.make, {
                            blockSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("S")),
                            children: React.createElement(Atom_Icon_Internal.make, {
                                  icon: {
                                    NAME: "Search",
                                    VAL: "White"
                                  }
                                })
                          }), React.createElement(Atom_Textfield.make, {
                            value: Belt_Option.getWithDefault(initialQuery, ""),
                            placeholder: Belt_Option.getWithDefault(placeholder, ""),
                            onChange: onChange,
                            required: true,
                            displayOrder: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 0),
                            style: /* HeaderSearch */4,
                            autoFocus: true,
                            autoSize: Particle_Screen_Constants.autoSizeAllPlaceAvailable,
                            focusOutline: /* None */19
                          }), React.createElement(Atom_Cta.Button.make, {
                            onClick: toggle,
                            screenReadersLabel: searchNavigation.closeLabel,
                            style: {
                              TAG: /* Header */10,
                              _0: /* Close */1
                            }
                          }))
              ) : React.createElement(Atom_Cta.Link.make, {
                    accessibility: Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Button", undefined, undefined),
                    ctaRef: ref,
                    href: searchNavigation.href,
                    onClick: handleSearchLinkCkick,
                    style: {
                      TAG: /* Header */10,
                      _0: /* Search */4
                    }
                  }), React.createElement(Atom_Text.ScreenreadersLabel.make, {
                  children: numberResultsLabel,
                  accessibility: Particle_Accessibility.make(true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Polite", undefined, undefined, undefined, undefined, undefined)
                }));
}

var make = Organism_SearchNavigation;

exports.make = make;
/* react Not a pure module */
